export default "__VITE_ASSET__BTZciC7a__"